import React, { useEffect, useRef, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import { Stack, Button, Grid, Modal, Container } from "@mui/material";
import SidebarMenu from "./SidebarMenu";
import EditIcon from "@mui/icons-material/Edit";
import ViewAllIssuesMenu from "./ViewAllIssuesMenu";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import FeedbackForm from "../FeedbackForm";
import ShareModal from "./ShareModal";
import { GetUserId } from "./HelperFunctions";
import './Header.css'
import { BASE_URL } from "../config/network/ApiUrl";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [likeData, setLikeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [feedbackOpen, setFeedbackOpen] = useState(false); // 👈 For feedback modal
  const location = useLocation();
  const [shareOpen, setShareOpen] = useState(false);
  const [shareData, setShareData] = useState(null);
  const [liked, setLiked] = useState(false);
  const [issuesData, setIssuesData] = useState({ field_release_date: "" });
  const [showHeader, setShowHeader] = useState(true);
  const storydata = location?.state?.story;
  const allStories = location?.state?.data;
  const pathParts = location?.pathname?.split("/");
  const navigate = useNavigate();

  const lastScrollY = useRef(0);
  const selectedYear = pathParts[1];
  const selectedMonth = pathParts[2];
  const selectedIssue = pathParts[3];
  console.log("storydata", storydata)
  console.log("likeData", likeData)
  console.log("liked", liked)
  console.log("allStories11", allStories)
  console.log("storydata?.id", storydata?.id, "selectedYear", selectedYear, "selectedMonth", selectedMonth, "selectedIssue", selectedIssue,)

  console.log("issue date data", issuesData)

  const dateObj = new Date(issuesData?.field_release_date ? issuesData?.field_release_date : "");
  const day = dateObj?.getDate();                 // 29
  const month = dateObj?.toLocaleString("en-US", { month: "short" });   // "Sep"
  const year = dateObj?.getFullYear();            // 2025

  console.log("day", day, "month", month, "year", year);
  console.log("date in header", data);
  console.log("node Id", storydata?.id)



  useEffect(() => {
    setLikeData([])
  }, [storydata?.id]);

  const HIDE_THRESHOLD = 55;

  const lastScroll = React.useRef(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > lastScroll.current && currentScroll > 80) {
        // scrolling DOWN → hide
        setShowHeader(false);
      } else {
        // scrolling UP → show
        setShowHeader(true);
      }
      lastScroll.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);




  useEffect(() => {
    const fetchIssuesData = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}api/inside-pages?year=${selectedYear}&month=${selectedMonth}&issue_number=${selectedIssue.split("-")[1]}`
        );
        console.log("date API", res)
        setIssuesData(res?.data?.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load sidebar data");
      }
    };

    const fetchIssuesDataWithoutParams = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}api/inside-pages`
        );
        setIssuesData(res?.data?.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load sidebar data");
      }
    }
    if (selectedYear && selectedMonth && selectedIssue) {
      fetchIssuesData();
    } else {
      fetchIssuesDataWithoutParams()
    }
  }, [selectedYear, selectedMonth, selectedIssue]);

  // useEffect(() => {
  //     const fetchStories = async () => {
  //         // setLoading(true);
  //         try {
  //             const res = await axios.get(`${BASE_URL}api/inside-pages`);
  //             const data = res?.data?.data?.items || [];
  //             console.log("latest issue data>>", data)

  //             // Show banner (field_intro_inside_page == null) first
  //             const firstStory = data?.find(
  //                 (item) => item?.field_intro_inside_page === null
  //             );
  //             const remainingStories = data?.filter(
  //                 (item) => item?.field_intro_inside_page !== null
  //             );
  //             const ordered = firstStory ? [firstStory, ...remainingStories] : remainingStories;
  //             setData(ordered);
  //         } catch (err) {
  //             setError("Failed to load stories");
  //         } finally {
  //             // setLoading(false);
  //         }
  //     };
  //     fetchStories();
  // }, [ ]);



  // 🟢 Fetch initial like state when page loads
  // useEffect(() => {
  //   if (!storydata?.id) return;
  //   const fetchLikes = async () => {
  //     try {
  //       const res = await axios.get(
  //         `${BASE_URL}api/node/${storydata?.id}/like`
  //       );
  //       console.log("get like data", res)
  //       setLikeData(res?.data);
  //       setLiked(res?.data?.user_reaction === "like");
  //     } catch (err) {
  //       console.error("Error fetching like data:", err);
  //     }
  //   };
  //   fetchLikes();
  // }, [storydata?.id]);


  // 🟢 Fetch initial like state when page loads
  useEffect(() => {
    const fetchLikes = async () => {
      try {
        if (storydata?.id) {
          const res = await axios.get( 
            `${BASE_URL}api/node/${storydata?.id}/like?google_user_id=${GetUserId()}&refresh=${new Date().getTime()}`
          );
          console.log("get like data11", res)
          setLikeData(res?.data);
          setLiked(res?.data?.user_reaction === "like");
        } else if (selectedYear && selectedMonth && selectedIssue) {
          const res = await axios.get(`${BASE_URL}api/issues/${selectedYear}/${selectedMonth}/${selectedIssue.split("-")[1]}/data?google_user_id=${GetUserId()}&refresh=${new Date().getTime()}`);
          console.log("get like data 22", res)
          setLikeData(res?.data);
          setLiked(res?.data?.user_reaction === "like");
        } else {        
          const res = await axios.get(`${BASE_URL}api/nodes/likes?google_user_id=${GetUserId()}&refresh=${new Date().getTime()}`);
          console.log("Total likes count", res)
          setLikeData(res?.data);
          setLiked(res?.data?.user_reaction === "like");
        }
      } catch (err) {
        console.error("Error fetching like data:", err);
      }
    };

    fetchLikes();
  }, [storydata?.id, selectedYear, selectedMonth, selectedIssue]);



  const handleLike = async () => {
    //  if (!storydata?.id) return;
    if (storydata?.id) {
      const body = {
        action: liked ? "remove" : "like",
        google_user_id: GetUserId()
      };

      console.log("body", body)
      // setLoading(true);
      try {
        const res = await axios.post(`${BASE_URL}api/node/${storydata?.id}/like`, body);
        console.log("Like API response 11", res)
        // ✅ Update UI based on response
        setLikeData(res?.data ? res?.data : []);
        setLiked(res?.data?.user_reaction === "like");
      } catch (err) {
        console.log("error", err)
        console.error(err);
      } finally {
        // setLoading(false);
      }

    } else if (selectedYear && selectedMonth && selectedIssue) {
      const body = {
        action: liked ? "remove" : "like",
        google_user_id: GetUserId()
      };

      console.log("body", body)
      try {
        const res = await axios.post(`${BASE_URL}api/issues/${selectedYear}/${selectedMonth}/${selectedIssue.split("-")[1]}/data`, body);
        console.log("Like API response 22", res)
        setLikeData(res?.data ? res?.data : []);
        setLiked(res?.data?.user_reaction === "like");
      } catch (err) {
        console.log("error", err)
        console.error(err);
      } finally {
      }

    } else {
      const body = {
        action: liked ? "remove" : "like",
        google_user_id: GetUserId()
      };

      console.log("body", body)
      try {
        const res = await axios.post(`${BASE_URL}api/nodes/likes`, body);
        console.log("Like API response 33", res)
        setLikeData(res?.data ? res?.data : []);
        setLiked(res?.data?.user_reaction === "like");
      } catch (err) {
        console.log("error", err)
        console.error(err);
      } finally {
      }

    }
  }


  const handleShare = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}api/share/${storydata?.id}`);
      console.log("Share API response", res)
      setShareData(res.data);
      setShareOpen(true);
    } catch (err) {
      console.error("Error fetching share data:", err);
    } finally {
      setLoading(false);
    }
  };

  const LikeIconSVG = ({ width = "24px", height = "24px", }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width={width}
        height={height}
        viewBox="370.909 0 1178.182 1021.091"
        xmlSpace="preserve"      
        style={{ fill: liked ? "#ffe505":"#ffffff", fontFamily: "OpenSans-Regular", fontSize: "14px" }}
      >
        <g>
          <g transform="translate(-10.000000, -14.000000)">
            <g transform="translate(10.000000, 14.000000)">
              <path d="M1001.227,1007.324c-12.272,9.161-26.754,13.767-41.236,13.767c-14.481,0-28.964-4.605-41.236-13.767     
              c-113.793-85.089-428.785-328.406-503.402-468.536C323.87,366.992,378.14,147.275,536.63,48.096     
              C588.716,15.484,645.538,0,701.601,0c98.329,0,194.326,47.623,258.39,134.031C1024.104,47.598,1120.076,0,1218.381,0     
              c56.062,0,112.885,15.484,164.994,48.096c158.466,99.179,212.76,318.896,121.279,490.692     
              C1430.036,678.918,1115.02,922.235,1001.227,1007.324z M1357.382,89.894c-42.464-26.587-90.524-40.628-139.001-40.628     
              c-85.369,0-165.191,41.599-219.02,114.166l-39.371,53.1l-39.396-53.1C866.815,90.889,786.97,49.266,701.601,49.266     
              c-48.478,0-96.538,14.041-139.001,40.628c-136.743,85.586-183.355,276.551-103.95,425.693     
              c70.838,133.01,392.531,379.788,489.461,452.255c4.394,3.286,8.886,3.983,11.88,3.983s7.486-0.697,11.904-3.983     
              c96.906-72.467,418.623-319.245,489.462-452.255C1540.761,366.444,1494.148,175.48,1357.382,89.894z" />
            </g>
          </g>
        </g>
      </svg>
    );
  };


  const ShareIconSVG = ({ width = "24px", height = "24px" }) => {
    return (
      <Box
        component="span"
        sx={{
          width,
          height,
          display: "inline-block",
          cursor: "pointer",
          fontFamily: "OpenSans-Regular", fontSize: "14px", lineHeight: "23px",
          "& svg": {
            fill: "#ffffff",
            transition: "0.2s ease-in-out",
          },

          "&:hover svg": {
            fill: "#ffe505",
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="100%"
          height="100%"
          viewBox="452.4 32.724 1013.407 1013.407"
          xmlSpace="preserve"
        >
          <path d="M1282.499,679.525c-63.903,0-120.215,32.918-153.025,82.642L807.979,601.431c6.998-19.397,11.026-40.22,11.026-62.003  
        c0-21.784-4.018-42.606-11.026-62.003l321.505-160.736c32.821,49.723,89.121,82.642,153.025,82.642  
        c101.066,0,183.298-82.231,183.298-183.298s-82.231-183.308-183.309-183.308s-183.309,82.231-183.309,183.297  
        c0,21.784,4.018,42.584,11.026,61.981L788.712,438.75c-32.821-49.713-89.11-82.62-153.004-82.62  
        c-101.077,0-183.308,82.221-183.308,183.298s82.23,183.298,183.297,183.298c63.904,0,120.193-32.919,153.015-82.62l321.494,160.747  
        c-6.987,19.386-11.016,40.197-11.016,61.971c0,101.066,82.231,183.308,183.309,183.308s183.298-82.23,183.298-183.308  
        S1383.576,679.525,1282.499,679.525z M1282.499,75.924c77.241,0,140.098,62.845,140.098,140.098s-62.846,140.098-140.098,140.098  
        c-77.253,0-140.108-62.845-140.108-140.098S1205.246,75.924,1282.499,75.924z M635.697,679.525  
        c-77.252,0-140.098-62.846-140.098-140.098c0-77.253,62.846-140.098,140.098-140.098c77.253,0,140.098,62.845,140.098,140.098  
        C775.795,616.68,712.95,679.525,635.697,679.525z M1282.499,1002.92c-77.253,0-140.108-62.845-140.108-140.107  
        c0-77.242,62.845-140.098,140.108-140.098c77.241,0,140.098,62.845,140.098,140.098  
        C1422.597,940.075,1359.751,1002.92,1282.499,1002.92z"/>
        </svg>
      </Box>
    );
  };


  return (
    <>
     <AppBar
  position="fixed"
  sx={{
    backgroundColor: "#dc042b",
    top: showHeader ? 0 : "-100px",
    transition: "top 0.45s ease",
    zIndex: 99,
    fontFamily: "Georama-Regular",
  }}
>

 {/* ---------------------------------------------------- */}
{/* PERFECT MOBILE HEADER (xs–sm) – MATCHES PROVIDED UI */}
{/* ---------------------------------------------------- */}

{/* ---------------------------------------------------- */}
{/* MOBILE HEADER EXACT LIKE OFFICIAL ECHO (xs–sm)       */}
{/* ---------------------------------------------------- */}

<Box
  sx={{
    display: { xs: "block", md: "none" },
    width: "100%",
    backgroundColor: "#dc042b",
    color: "#fff",
    paddingBottom: "6px",
  }}
>
<Container>
  {/* ------------------- ROW 1 -------------------- */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 1.6,
      pt: 1.2,
      pb: 0.8,
      position: "relative",
    }}
  >

    {/* LEFT: Toggle + Date */}
    <Stack direction="row" alignItems="center" spacing={1.4}>
      <div className="button_container" id="toggle" onClick={() => setOpen(true)}>
        <span className="top"></span>
        <span className="middle"></span>
        <span className="bottom"></span>
      </div>

      <Box
        sx={{
          backgroundColor: "#d71920",
          px: 1.2,
          py: 0.6,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          height: "36px",
        }}
      >
        <Typography sx={{ fontSize: "18px", mr: "4px", fontFamily: "Georama-Regular" }}>
          {day}
        </Typography>

        <Box sx={{ lineHeight: 1 }}>
          <Typography sx={{ fontSize: "10px", textTransform: "capitalize" }}>
            {month}
          </Typography>
          <Typography sx={{ fontSize: "10px", mt: "-3px" }}>{year}</Typography>
        </Box>
      </Box>
    </Stack>

    {/* CENTER: Echo Logo */}
    <Box
      component="img"
      src="https://echo.mahindra.com/public/front_assets/images/echo-logo.png"
      sx={{
        width: "70px",
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        top: "50%",
        marginTop: "-20px",
        cursor: "pointer",
          paddingBottom:"0px"
      }}
      onClick={() => navigate("/")}
    />

    {/* RIGHT: Mahindra Logo */}
    <Box
      component="img"
      src="https://echo.mahindra.com/public/front_assets/images/mahindra-rise-logo-white-new.png"
      sx={{ height: "20px" }}
    />

  </Box>

  {/* ------------------- ROW 2 -------------------- */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 1.6,
      padding:'0px'
    }}
  >

    {/* LEFT: Toggle + Date (repeat same UI like official site) */}
    <Stack direction="row" alignItems="center" spacing={1.4}>
      <ViewAllIssuesMenu setData={setData} />
    </Stack>

    {/* RIGHT: Icons */}
    <Stack direction="row" alignItems="center" spacing={1.8}>
      <Box display="flex" alignItems="center" gap={0.4} onClick={handleLike} sx={{ cursor: "pointer", "&:hover svg path": { fill: "#ffe505" },"&:hover .like-count": {color: "#ffe505"} }}>
        <LikeIconSVG />
        <Typography  className="like-count" sx={{ color: liked ? "#ffe505": "#ffffff", fontSize: "12px",transition: "color 0.2s" }}>{likeData?.like_count}</Typography>
      </Box>
      <Box sx={{ cursor: "pointer" }} onClick={handleShare}>
        <ShareIconSVG />
      </Box>

      <i
        className="sprite-icon feedback-icon"
        style={{ cursor: "pointer" }}
        onClick={() => setFeedbackOpen(true)}
      ></i>
    </Stack>

  </Box>
</Container>
</Box>



  {/* ---------------------------------------------------- */}
  {/* DESKTOP/TABLET HEADER – UNCHANGED (md–xl)            */}
  {/* ---------------------------------------------------- */}
  <Box sx={{ display: { xs: "none", md: "block" } }}>
    <Container>
      <Toolbar sx={{ justifyContent: "space-between", flexWrap: "wrap" }}>

        {/* LEFT SECTION */}
        <Stack direction="row" alignItems="center" spacing={2}>

          {/* Hamburger */}
          <div className="button_container" id="toggle" onClick={() => setOpen(true)}>
            <span className="top"></span>
            <span className="middle"></span>
            <span className="bottom"></span>
          </div>

          {/* Date Box */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              backgroundColor: "#d71920",
              color: "#fff",
              padding: "6px 10px",
              borderRadius: "4px",
            }}
          >
            <Typography
              sx={{
                fontSize: "25px",
                lineHeight: "25px",
                marginRight: "1px",
                marginTop: "10px",
                fontFamily: "Georama-Regular",
              }}
            >
              {day}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  textTransform: "capitalize",
                  marginTop: "5px",
                  fontFamily: "OpenSans-Regular",
                }}
              >
                {month}
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontFamily: "OpenSans-Regular",
                  marginTop: "-4.5px",
                }}
              >
                {year}
              </Typography>
            </Box>
          </Box>

          {/* VIEW ALL ISSUES MENU */}
          <ViewAllIssuesMenu setData={setData} />

        </Stack>

        {/* CENTER LOGO */}
        <Typography
          variant="h5"
          sx={{ fontFamily: "cursive", fontWeight: 700, textAlign: "center" }}
        >
          <Box
            component="img"
            src="https://echo.mahindra.com/public/front_assets/images/echo-logo.png"
            sx={{ cursor: "pointer", maxWidth: "100%" }}
            onClick={() => navigate("/")}
          />
        </Typography>

        {/* RIGHT SECTION */}
        <Stack direction="row" alignItems="center" spacing={2.5} sx={{ marginRight: "-1.8%" }}>
          <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer", "&:hover svg path": { fill: "#ffe505" },"&:hover .like-count": {color: "#ffe505"},}} onClick={() => handleLike()}>
            <LikeIconSVG />
            <Typography  className="like-count" sx={{ color: liked ? "#ffe505": "#ffffff", fontFamily: "OpenSans-Regular", fontSize: "14px" ,transition: "color 0.2s",}}>
              {likeData?.like_count}
            </Typography>
          </Box>
          <Box sx={{ cursor: "pointer" }} onClick={handleShare}>
            <ShareIconSVG />
          </Box>

          <Box
            component="ul"
            className="right-nav-control nav-control"
            sx={{
              display: "flex",
              alignItems: "center",
              padding: 0,
              margin: 0,
              listStyle: "none",
              gap: 2,
            }}
          >
            <li>
              <a className="icon-link" onClick={() => setFeedbackOpen(true)}>
                <i className="sprite-icon feedback-icon"></i>
              </a>
            </li>
          </Box>

          <Box
            component="img"
            src="https://echo.mahindra.com/public/front_assets/images/mahindra-rise-logo-white-new.png"
            alt="Mahindra Rise"
            sx={{ height: 24 }}
          />
        </Stack>

      </Toolbar>
    </Container>
  </Box>

</AppBar>


      <SidebarMenu open={open} onClose={() => setOpen(false)} data={data} />
      {/* 🟢 Feedback Modal */}
      <Modal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        aria-labelledby="feedback-modal"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backdropFilter: "blur(3px)",
        }}
      >
        <Box>
          <FeedbackForm onClose={() => setFeedbackOpen(false)} />
        </Box>
      </Modal>

      {/* Share Modal */}
      <ShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        shareData={shareData}
        loading={loading}
      />


    </>
  );
};

export default Header;
